export enum MEMBER_TYPES {
  Free = 'FREE',
  Basic = 'BA',
  Extra = 'XT',
  Pro = 'PRO'
};

export type MemberType = typeof MEMBER_TYPES[keyof typeof MEMBER_TYPES];

export function isMemberType(unknownValue: unknown): unknownValue is MemberType {
  return (Object.values(MEMBER_TYPES) as unknown[]).includes(unknownValue);
}
